// extracted by mini-css-extract-plugin
module.exports = {"emptyNotice":"Notice_emptyNotice__3PhFR","noticeItem":"Notice_noticeItem__2COLK","iconWrap":"Notice_iconWrap__3b1UN"};